module.exports = __webpack_public_path__ + "public/img/slb2x.9289ca00.png";